export const TopbarFields = [
    { identifier: 'topbar-bg', type: 'input', field: 'topbar-bg' },
    {
        identifier: 'font-size-topbar',
        type: 'input',
        field: 'font-size-topbar'
    }
]
